import authReducer from 'store/reducers/auth'
import globalReducer from 'store/reducers/global'
import callReducer from 'store/reducers/call'
import profileReducer from 'store/reducers/profile'
import userAgentReducer from 'store/reducers/userAgent'
import settingsReducer from 'store/reducers/settings'

export default {
    auth: authReducer,
    global: globalReducer,
    call: callReducer,
    profile: profileReducer,
    settings: settingsReducer,
    userAgent: userAgentReducer
}
